import { AxiosError } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getResponseError } from '@utils/error';
import { SagaPayload } from '@utils/typescript';
import { AuthApi } from '@apis/AuthApi';
import { currentUserFetch } from '@components/Auth';
import {
  mobileNumberUpdate,
  UpdateMobileNumberPayload,
  mobileNumberUpdateSuccess,
  mobileNumberUpdateError,
  otpCodeRequest,
  OtpCodeRequestPayload
} from './action';

function* handleMobileNumberUpdate({ payload }: SagaPayload<UpdateMobileNumberPayload>) {
  try {
    yield call(AuthApi.updateMobileNumber, payload);
    yield put(mobileNumberUpdateSuccess());
    yield put(currentUserFetch())
  } catch (e) {
    const { errors } = getResponseError(e as AxiosError);
    yield put(mobileNumberUpdateError({ errors }));
  }
}

function* handleOtpCodeRequest({ payload }: SagaPayload<OtpCodeRequestPayload>) {
  yield call(AuthApi.requestOtpCodeForMobileNumber, payload);
}

export default function* () {
  yield takeLatest(mobileNumberUpdate, handleMobileNumberUpdate);
  yield takeLatest(otpCodeRequest, handleOtpCodeRequest);
}
